import { Button } from '@tremor/react';
import { exportTableCsv, exportTablePdf } from '../lib/exportTable';
import type { ExportColumn } from '../lib/exportTable';
import { t } from '../lib/i18n';

/**
 * "Descargar CSV" / "Descargar PDF" pair for a page's result table. Give it the
 * page's FULL row set (never the paginated slice) plus the column spec it shares
 * with lib/exportTable; both buttons stay disabled until rows exist. Carries
 * `no-print` since exports are a screen-only control.
 */
interface Props<T> {
  /** PDF document title (usually the page title). */
  title: string;
  /** Base filename without extension, e.g. "Ventas 2026-09-01 2026-09-07". */
  filename: string;
  /** PDF meta lines: date range, filters, store. */
  meta?: string[];
  printedBy: string;
  columns: ExportColumn<T>[];
  rows: readonly T[] | null | undefined;
  orientation?: 'portrait' | 'landscape';
  className?: string;
}

export default function ExportButtons<T>({
  title, filename, meta, printedBy, columns, rows, orientation, className,
}: Props<T>) {
  const disabled = !rows || rows.length === 0;
  return (
    <div className={'no-print flex items-center gap-2' + (className ? ' ' + className : '')}>
      <Button
        size="xs"
        variant="secondary"
        disabled={disabled}
        onClick={() => { if (rows) exportTableCsv(filename, columns, rows); }}
      >
        {t.exportButtons.csv}
      </Button>
      <Button
        size="xs"
        variant="secondary"
        disabled={disabled}
        onClick={() => { if (rows) exportTablePdf({ title, meta, printedBy, filename, columns, rows, orientation }); }}
      >
        {t.exportButtons.pdf}
      </Button>
    </div>
  );
}
